// extracted by mini-css-extract-plugin
export default {"CarLogosSection":"CarLogosSection_CarLogosSection__Ww1yM","LogosWrap":"CarLogosSection_LogosWrap__bLULl","LogosWrapItem":"CarLogosSection_LogosWrapItem__kk+ES"};